import { Link, useLocation } from 'react-router-dom'

const TABS = [
  { to: '/app/picasso', label: 'Search console', match: (p: string) => p === '/app/picasso' || /^\/app\/picasso\/s\/\d+/.test(p) },
  { to: '/app/picasso/sessions', label: 'Your sessions', match: (p: string) => p === '/app/picasso/sessions' },
  { to: '/app/picasso/shopper', label: 'Shopper searches', match: (p: string) => p.startsWith('/app/picasso/shopper') },
]

/** Page frame for the Picasso section: title, one line of explanation, the tabs. */
export function PicassoFrame({ title, description, actions, children }: {
  title: React.ReactNode
  description: React.ReactNode
  actions?: React.ReactNode
  children: React.ReactNode
}) {
  const { pathname } = useLocation()
  return (
    <div className="space-y-6 p-6">
      <div className="space-y-3">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0">
            <h1 className="text-2xl font-semibold">{title}</h1>
            <p className="max-w-4xl text-sm text-slate-500">{description}</p>
          </div>
          {actions}
        </div>
        <nav className="flex flex-wrap gap-1 border-b">
          {TABS.map((t) => (
            <Link
              key={t.to}
              to={t.to}
              className={`-mb-px border-b-2 px-3 py-2 text-sm ${
                t.match(pathname) ? 'border-slate-900 font-medium text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-800'
              }`}
            >
              {t.label}
            </Link>
          ))}
        </nav>
      </div>
      {children}
    </div>
  )
}
